const removeMark = (s: string): string => s.replaceAll(/\D/g, '');

export default removeMark;
